export default [
    {
        path: '/users',
        name: 'users',
        component: () => import(/* webpackChunkName: "Users" */ '@/views/users/Index.vue'),
        meta: {
            title: 'Gebruikers',
            requiresAuth: true,
        }
    },
    {
        path: '/users/create',
        name: 'addUser',
        component: () => import(/* webpackChunkName: "UsersCreate" */ '@/views/users/Create.vue'),
        meta: {
            title: 'Gebruiker toevoegen',
            requiresAuth: true,
        }
    },
    {
        path: '/users/edit/:id',
        name: 'editUser',
        component: () => import(/* webpackChunkName: "UsersEdit" */ '@/views/users/Edit.vue'),
        meta: {
            title: 'Gebruiker bewerken',
            requiresAuth: true,
        }
    }
];